/* tslint:disable */
/* eslint-disable */
export enum VisaCategory {
  None = 'None',
  SkilledMigrant = 'SkilledMigrant',
  EssentialSkills = 'EssentialSkills',
  SpecificPurpose = 'SpecificPurpose'
}
